import React from 'react';
import { useNavigate } from 'react-router-dom'; // 👈 Dodane
import homeImage from '../../images/majtkowe.jpg';
import HeroSection from '../../components/HeroSection';
import OfertaCard from '../../components/OfertaCard';
import '../../style/ofertacard.css';

import HomeIcon from '@mui/icons-material/Home';
import BusinessIcon from '@mui/icons-material/Business';


const Majatkowe = () => {
  const navigate = useNavigate(); // 👈 Dodane

  const handleCardClick = () => {
    navigate('/kontakt'); // 👈 Przekierowanie
  };

  const offerings = [
    {
      label: 'Ubezpieczenia mieszkaniowe',
      icon: <HomeIcon />,
      color: '#4E9F3D',
      description: 'Chroni Twój dom lub mieszkanie przed skutkami zdarzeń losowych takich jak pożar, zalanie czy kradzież.'
    },
    
    {
      label: 'Ubezpieczenia firmowe',
      icon: <BusinessIcon />,
      color: '#005F73',
      description: 'Kompleksowa ochrona majątku Twojej firmy, w tym nieruchomości, wyposażenia i odpowiedzialności cywilnej.'
    },
  ];

  return (
    <>
      <HeroSection
        image={homeImage}
        text="Ubezpieczenia majątkowe – zabezpiecz swój dobytek"
      />

      <section style={{ maxWidth: '1100px', margin: '2rem auto', padding: '0 1rem' }}>
        <h2>Ubezpieczenia majątkowe</h2>
        <p>
          Chronimy Twój majątek przed niespodziewanymi zdarzeniami, abyś mógł spać spokojnie.
          Oferujemy ubezpieczenia dostosowane do Twoich potrzeb.
        </p>

        <div className="oferta-buttons" style={{ justifyContent: 'center', marginTop: '2rem', gap: '1.8rem' }}>
          {offerings.map(({ label, icon, color, description }) => (
            <OfertaCard
              key={label}
              label={label}
              icon={icon}
              color={color}
              description={description}
              onClick={handleCardClick} // 👈 Przekazanie kliknięcia
            />
          ))}
        </div>
      </section>
    </>
  );
};

export default Majatkowe;
